import styled from "@emotion/styled";

export const AvailabilityItemWrapper = styled.div`
    display: inline-flex;
    gap: 6px;
    align-items: center;
`;
